export const actionTypes = {
    TOGGLE_MENU: "TOGGLE_MENU"
}
